import React, { useEffect, useRef, useState } from "react";
import { useUpload } from "../../context/UploadContext";
import styles from "./index.module.css";
import { MdDragIndicator } from "react-icons/md";
import { IoIosArrowDown, IoIosClose } from "react-icons/io";

const Loader = () => (
    <div className={styles.loader} />
);

export const UploadBar = () => {
    const { uploads, removeUpload, cancelUpload } = useUpload();
    const [open, setOpen] = useState(true);
    const [pos, setPos] = useState({
        x: window.innerWidth / 2 - 130,
        y: 12,
    });
    const [dragging, setDragging] = useState(false);
    const dragStart = useRef({ x: 0, y: 0 });

    const onMouseDown = (e) => {
        setDragging(true);
        dragStart.current = {
            x: e.clientX - pos.x,
            y: e.clientY - pos.y,
        };
    };

    const onMouseMove = (e) => {
        if (!dragging) return;
        setPos({
            x: e.clientX - dragStart.current.x,
            y: e.clientY - dragStart.current.y,
        });
    };

    const onMouseUp = () => setDragging(false);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [dragging]);

    const uploadList = Object.values(uploads);
    if (uploadList.length === 0) return null;

    return (
        <div
            className={styles.uploadPanel}
            style={{
                left: pos.x,
                top: pos.y,
                cursor: dragging ? "grabbing" : "default",
            }}
        >
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <IoIosArrowDown
                        size={18}
                        onClick={() => setOpen(!open)}
                        style={{
                            cursor: "pointer",
                            transition: "transform 250ms ease",
                            transform: open ? "rotate(0deg)" : "rotate(-90deg)",
                        }}
                    />
                    <span>Upload Status</span>
                </div>
                <div className={styles.headerRight}>
                    {!open && uploadList.some(u => u.status === 'uploading') && <Loader />}
                    <MdDragIndicator
                        onMouseDown={onMouseDown}
                        style={{ cursor: "grab" }}
                        size={22}
                    />
                </div>
            </div>

            {open && (
                <div className={styles.body}>
                    {uploadList.map((upload) => (
                        <div key={upload.id} className={styles.uploadItem}>
                            <div className={styles.itemInfo}>
                                <span className={styles.itemName} title={upload.name}>
                                    {upload.name}
                                </span>
                                {upload.status === "uploading" ? (
                                    <span className={styles.itemPercent}>{upload.progress}%</span>
                                ) : upload.status === "completed" ? (
                                    <span className={styles.itemStatusSuccess}>Done</span>
                                ) : (
                                    <span className={styles.itemStatusError}>Failed</span>
                                )}
                                {/* <IoIosClose
                                    size={20}
                                    className={styles.closeBtn}
                                    onClick={() => upload.status === 'uploading' ? cancelUpload(upload.id) : removeUpload(upload.id)}
                                /> */}
                            </div>
                            {upload.status === "uploading" && (
                                <div className={styles.progressBar}>
                                    <div
                                        className={styles.progressFill}
                                        style={{ width: `${upload.progress}%` }}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
